import { ReactNode, useId } from 'react';

import {
  FormGroup,
  FormGroupProps,
  FormHelpText,
  FormInput,
  FormInputIcon,
  FormInputIconProps,
  FormInputProps,
} from '@spotify-internal/encore-web';

export type FormTextFieldProps = Omit<FormInputProps, 'id' | 'error'> & {
  label: string;
  helperText?: ReactNode;
  error?: string | null;
  iconTrailing?: FormInputIconProps['iconTrailing'];
  indicator?: FormGroupProps['indicator'];
  'data-testid'?: string;
};

export const FormTextField = ({
  label,
  helperText,
  error,
  iconTrailing,
  indicator,
  name,
  required,
  size = 'small',
  'data-testid': dataTestId = name,
  ...inputProps
}: FormTextFieldProps) => {
  const inputId = useId();
  const helpTextId = useId();
  const helpText = error ?? helperText;

  return (
    <FormGroup
      label={label}
      labelFor={inputId}
      indicator={indicator}
      data-testid={dataTestId}
    >
      <FormInputIcon iconTrailing={iconTrailing}>
        <FormInput
          {...inputProps}
          id={inputId}
          name={name}
          size={size}
          error={Boolean(error)}
          required={required}
          aria-describedby={helpText ? helpTextId : undefined}
        />
      </FormInputIcon>
      {helpText && (
        <FormHelpText id={helpTextId} error={Boolean(error)}>
          {helpText}
        </FormHelpText>
      )}
    </FormGroup>
  );
};
